<template>
  <gift-pack-detail is-create />
</template>

<script>
import GiftPackDetail from './detail'
export default {
  name: 'CreateGiftPackage',
  components: { GiftPackDetail }
}
</script>
